export default "__VITE_ASSET__DtDdLX1h__"